import SvgIcon from "../../components/SvgIcon/SvgIcon"; // ✅ tu sistema de iconos

const CustomerFormPlaceholder = () => {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 opacity-80">
      <SvgIcon name="info-circle" className="w-16 h-16 text-primary mb-4" />

      <h3 className="text-gray-800 dark:text-gray-200 text-xl font-semibold mb-2">
        Datos del Cliente
      </h3>

      <p className="text-gray-600 dark:text-gray-400 max-w-lg text-sm leading-relaxed">
        Selecciona el tipo de entidad para visualizar los campos necesarios.
        Completa la información requerida para registrar correctamente al cliente.
      </p>
    </div>
  );
};

export default CustomerFormPlaceholder;
